export const content = {
  accent: {
    300: '#88D3EE',
    500: '#39A8DE',
    700: '#2C87BD',
  },
  negative: '#C62828',
  black: {
    10: '#D5D5D5',
    20: '#B9B9B9',
    25: '#9C9C9C',
    30: '#404040',
    Base: '#2C2C2C',
  },
  white: {
    10: '#F3F3F3',
    20: '#E5E5E5',
    Base: '#FFFFFF',
  },
  warning: '#F9A825',
  in_use: '#27AB62',
  review: '#8E24AA',
  primary: '#FFFFFF',
  secondary: '#B9B9B9',
};

export const surface = {
  accent: '#404040',
  primary: '#2C2C2C',
  secondary: '#4D4D4D',
};

export const cards = {
  error: content.negative,
  full: '#F57F17',
  lockboxfull: '#304FFE',
  readyForReview: content.review,
};

export const bins = {
  rxBin: '#2F4FFE',
  low: content.in_use,
  half: '#FFA500',
  full: content.negative,
};

export const Colors = {
  bins,
  cards,
  content,
  surface,
};
